const en = {
    'menu': ['Digital money', 'Innovation and Reliability', 'Stable Digital Asset', 'Why Use BVCPay', 'How To Use BVCPay'],
    'footmenu': ['HOME', 'ABOUT US', 'CONTACT', 'OTHER'],
    'part1_txt1': 'Digital Era, Digital Currency',
    'part1_txt2': 'The Universal Real-Time ',
    'part1_txt3': 'Payment Solution',
    'part1_txt4': '',
    'part1_txt5': 'Universal, fast, and secure',
    'part1_txt6': 'Download',

    'part2_txt1': 'Search transactions in BVC-Chain:',
    'part2_txt2': 'For business inquiries, please email us at：',
    'part2_txt11': "Access to BVC-Chain's developer platform:",
    'part2_txt22': 'BVC-Chain Github: ',
    'part2_txt3': 'Innovation and Reliability',
    'part2_txt4': 'With efficiency of blockchain technology and stability of traditional currency.',

    'part3_txt1': 'Stable Digital Asset',
    'part3_txt2': 'BVC converts cash into digital currency, which is anchored  to the value of fiat currency.',
    'part3_txt3': '',
    'part3_txt4': '100% Asset Backed',
    'part3_txt5': 'Each CADT is backed by a Canadian Dollar held in an escrow account. This ensures a one-to-one value of 1CADT = $1 CAD.',
    'part3_txt6': 'Transparent',
    'part3_txt7': 'The Canadian Dollars held in our escrow account are reconciled and published everyday.The CADT in circulation are consistent with the funds held in escrow.',
    'part3_txt8': 'Secure and Trusted',
    'part3_txt9': 'BVCI is a financial services company incorporated in Ontario, Canadian, and has extensive legal and digital asset brokerage experience. CADT is a digital asset minted by BVCI, 100% backed by the Canadian dollar.',
    'part3_txt10': 'Real-Time',
    'part3_txt11': 'Use BVCI to settle any digital transactions on the blockchain 24/7/365. You are able to convert the digital assets back to the equivalent of the fiat currency with redemption processed within 3 business days.',

    'part4_txt1': 'Why Use BVCPay',
    'part4_txt2': 'The digital assets pledged by the Canadian dollar are freely redeemable back to fiat currency.',
    'part4_txt3': 'Transfering of digital assets can be done at a fraction of the cost.',
    'part4_txt4': 'Payment and settlement of transactions is available 24/7/365 anywhere around the world.',
    'part4_txt5': 'Fast,secure, private cross-border transactions.',
    'part4_txt6': 'The BVCI platform is built on open blockchain technologies, leveraging the security, efficiency and transparency that they provide.',

    'part5_txt1': 'How To Use BVCPay',
    'part5_txt2': 'USER MANUAL (English Version)',
    'part5_txt3': 'USER MANUAL (Chinese Version)',
    'part5_txt4': 'USER MANUAL (Video)',
    'part5_txt5': 'ABOUT US (Video)',

    'dl_txt1': 'BvcPay',
    'dl_txt2': 'A decentralized asset transaction and payment application based on blockchain technology',
    'dl_txt3': 'Safe',
    'dl_txt4': 'Reliable',
    'dl_txt5': 'Decentralized',
    'dl_txt6': 'Safe and reliable',
    'dl_txt7': 'Native support of multi-asset and decentralized asset transaction in BVC-Chain ecosystem.',
    'dl_txt8': 'Decentralization',
    'dl_txt9': 'The private key is only owned by users and all transaction data is 100% real and all assets are safe, compared with the centralization solution.',
    'dl_txt10': 'Safe and reliable',
    'dl_txt11': 'The BVC2L algorithm is used to ensure safety, reliability and efficiency.',
    'dl_txt12': 'Trusted and effective',
    'dl_txt13': 'Free of manipulation, all transaction records on chain are trustable and can be queried based on the account address on a real time basis.',
    'dl_txt14': 'Function introduction',
    'dl_txt15': 'Convenient, fast and efficient',
    'dl_txt16': 'Asset management',
    'dl_txt17': 'Query multiple asset holding profiles.',
    'dl_txt18': 'Asset credit, transaction password setting.',
    'dl_txt19': 'Multiple protection of addresses, private keys and transaction passwords to ensure the asset security.',
    'dl_txt20': 'Asset transaction',
    'dl_txt21': 'Total assets,clearly visible.',
    'dl_txt22': 'View historical transaction details to ensure clear accounts.',
    'dl_txt23': 'Easy and fast transfer by collection address asset transfer.',
    'dl_txt24': 'Contacts management',
    'dl_txt25': 'Quick and easy maintenance of contact addresses.',
    'dl_txt26': 'Transfer between contacts is faster and easier.',
    'dl_txt27': 'Quickly query and filter contacts and payment addresses.',

    'direct_download': 'Direct Download'
}

export default en